import 'slick-carousel'

;(function($) {
    $(function() {
        let sliderKey = 'data-aka-slider';
        $(`[${sliderKey}]`).each(function slider() {
            let roleKey = `${sliderKey}-role`;
            let defaultOptions = {
                arrows: true,
                autoplay: false,
                infinite: false,
                dots: false,
                slidesToScroll: 1,
            };
            let customOptions = $(this).data('aka-slider-options');
            let prevArrow = $(this).find(`[${roleKey}="prevArrow"]`);
            let nextArrow = $(this).find(`[${roleKey}="nextArrow"]`);

            let inlineOptions = {};

            if (prevArrow) {
                defaultOptions.prevArrow = $(prevArrow);
            }
            if (nextArrow) {
                defaultOptions.nextArrow = $(nextArrow);
            }

            let options = { ...defaultOptions, ...customOptions };

            if (!options.arrows) {
                $(nextArrow).hide();
                $(prevArrow).hide();
            }

            const slides = $(this).find(`[${roleKey}="slides"]`);
            slides.slick(options);
        });
    });
})(jQuery)